export default "assets/images/b9ae27f0a01228380dff76a33b605707.jpg";